import React, { Fragment, useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { FormHelperText, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';

export const styles = {
  input: {
    fontWeight: 600,
  },
  disabled: {
    backgroundColor: '#ededed',
    color: '#8d8d8d',
  },
  typography: {
    color: '#707070',
    marginBottom: '5px',
  },
  inputBaseRoot: {
    border: 'none',
  },
  inputRoot: {
    '&::placeholder': {
      fontSize: 16,
      color: '#979797',
    },
  },
};

function AxlDatePicker(props) {
  const { label, disabled, errorMessage, allowClickInputOpen, ...otherProps } = props;
  const [open, setOpen] = useState(false);

  const datePickerSx = {
    '.MuiOutlinedInput-input': {
      padding: '9px 14px',
    },
    ...(disabled ? styles.disabled : {}),
  };

  const newProps = !allowClickInputOpen
    ? {
        ...otherProps,
      }
    : {
        ...otherProps,
        open: !disabled && open,
      };

  return (
    <Fragment>
      {label && <Typography sx={styles.typography}>{label}</Typography>}
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DatePicker
          variant={props.variant || 'inline'}
          inputVariant={props.inputVariant || 'outlined'}
          autoOk
          fullWidth
          disabled={disabled}
          slotProps={{
            textField: {
              size: props.size || 'small',
              onClick: () => {
                if (!disabled) setOpen(true);
              },
              fullWidth: true,
              sx: styles.inputBaseRoot,
              placeholder: props.placeholder || 'MM/DD/YYYY',
            },
            field: { readOnly: true },
            openPickerButton: {
              onClick: () => {
                if (!disabled) setOpen(true);
              },
            },
          }}
          {...newProps}
          open={open}
          onClose={() => setOpen(false)}
          sx={datePickerSx}
        />
        {errorMessage && (
          <FormHelperText error={!!errorMessage} style={{ color: '#d0021b', fontWeight: 'bold' }}>
            {errorMessage}
          </FormHelperText>
        )}
      </LocalizationProvider>
    </Fragment>
  );
}

export default AxlDatePicker;
